import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";
import config from "../../config";

const api = new APICore();

function fetchChargesApi(params: FilterMetadata) {
  const baseUrl = `${config.BACKEND_BASE_URL}/charges`;
  return api.get(`${baseUrl}`, params);
}

function fetchChargeApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${params}`;
  return api.get(`${baseUrl}`, {});
}

function createChargeApi(params: any) {
  let backendApiUrl = "";

  let apiData: any = {
    programmeExternalId: params?.programme ? params?.programme : "",
    borrowerExternalId: params?.borrowerExternalId ? params?.borrowerExternalId : "",
    chargeType: params?.chargeType ? params?.chargeType : "",
    gstPercentage: params?.gstPercentage ? params?.gstPercentage : 0,
    amountWithoutGst: params?.amountWithoutGst ? params?.amountWithoutGst : "",
    gstAmount: params?.gstAmount ? params?.gstAmount : 0,
    totalAmount: params?.amount ? params?.amount : "",
    comment: params?.comment ? params?.comment : null,
    impactOutstanding: params?.impactOutstanding,
    chargeSettlementStrategy: params?.chargeSettlementStrategy ? params?.chargeSettlementStrategy : "OnRepayment",
    valueDate: params?.valueDate ? params?.valueDate : "",
  };

  if (params.exposureOn === "Anchor") {
    apiData.customerRelationExternalId = null
  }

  if (params.exposureOn === "CounterParty") {
    apiData.customerRelationExternalId = params?.customerRelationExternalId ? params?.customerRelationExternalId : ""
  }

  if (!params.draft) {
    apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";

    backendApiUrl = `${config.BACKEND_BASE_URL}/charges`;
  } else {
    backendApiUrl = `${config.BACKEND_BASE_URL}/charges?draft=${params.draft}`;
  }
  const baseUrl = backendApiUrl;
  return api.create(`${baseUrl}`, apiData);

}

function updateChargeApi(params: any) {
  let backendApiUrl = "";

  let apiData: any = {
    programmeExternalId: params?.programmeExternalId ? params?.programmeExternalId : "",
    borrowerExternalId: params?.borrowerExternalId ? params?.borrowerExternalId : "",
    chargeType: params?.chargeType ? params?.chargeType : "",
    gstPercentage: params?.gstPercentage ? params?.gstPercentage : "",
    amountWithoutGst: params?.amountWithoutGst ? params?.amountWithoutGst : "",
    gstAmount: params?.gstAmount ? params?.gstAmount : "",
    totalAmount: params?.totalAmount ? params?.totalAmount : "",
    comment: params?.comment ? params?.comment : null,
    impactOutstanding: params?.impactOutstanding,
    chargeSettlementStrategy: params?.chargeSettlementStrategy ? params?.chargeSettlementStrategy : "OnRepayment",
    valueDate: params?.valueDate ? params?.valueDate : "",
  };


  if (params.customerRelationExternalId === null) {
    apiData.customerRelationExternalId = null
  }else {
    apiData.customerRelationExternalId = params?.customerRelationExternalId ? params?.customerRelationExternalId : ""
  }

  if (!params.draft) {
    apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";
    backendApiUrl = `${config.BACKEND_BASE_URL}/charges/${params.externalId}`;
  } else {
    backendApiUrl = `${config.BACKEND_BASE_URL}/charges/${params.externalId}?draft=${params.draft}`;
  }

  const baseUrl = backendApiUrl;
  return api.update(`${baseUrl}`, apiData);
}

function fetchChargeVersionApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${params}/versions`;
  return api.get(`${baseUrl}`, params);
}


function deleteChargeApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${params}`;
  return api.delete(`${baseUrl}`);
}


function fetchChargeVersionDetailsApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${params?.externalID}/versions/${params?.internalID}`;
  return api.get(`${baseUrl}`, {});
}

function fetchChargeLatestVersionApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${params?.externalId}/latestVersion`;
  return api.get(`${baseUrl}`, {});
}



function approveChargeApi(params: any) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  let externalId = params.externalId;
  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${externalId}/approve`;
  return api.updatePatch(`${baseUrl}`, remarks);
}
function rejectChargeApi(params: any) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };

  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${params?.externalId}/reject`;
  return api.updatePatch(`${baseUrl}`, remarks);
}

function blockChargeApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${params.id}/block`;
  return api.updatePatch(`${baseUrl}`, param);
}

function freezeChargeApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${params.id}/freeze`;
  return api.updatePatch(`${baseUrl}`, param);
}

function unFreezeChargeApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/charges/${params.id}/unfreeze`;
  return api.updatePatch(`${baseUrl}`, param);
}

export {
  fetchChargesApi,
  fetchChargeApi,
  createChargeApi,
  updateChargeApi,
  fetchChargeVersionApi,
  approveChargeApi,
  rejectChargeApi,
  blockChargeApi,
  freezeChargeApi,
  unFreezeChargeApi,
  fetchChargeVersionDetailsApi,
  fetchChargeLatestVersionApi,
  deleteChargeApi
};
